import React from 'react';
import styles from './CTAButton.module.css';

interface CTAButtonProps {
  onClick?: () => void;
  href?: string;
  large?: boolean;
  variant?: 'red' | 'white';
  className?: string;
  children: React.ReactNode;
}

export function CTAButton({ onClick, href, large = false, variant = 'red', className = '', children }: CTAButtonProps) {
  const sizeClass = large ? styles['size-large'] : styles['size-default'];
  const variantClass = variant === 'white' ? styles['front-white'] : styles['front-red'];
  const edgeClass = variant === 'white' ? styles['edge-white'] : styles['edge-red'];
  const frontClass = ['btn-3d-front', styles['front-base'], variantClass, sizeClass].join(' ');

  const inner = (
    <>
      <span className="btn-3d-shadow" />
      <span className={['btn-3d-edge', edgeClass].join(' ')} />
      <span className={frontClass}>
        {children}
      </span>
    </>
  );

  const wrapperClass = ['btn-3d', styles['wrapper'], className].filter(Boolean).join(' ');

  if (href) {
    return (
      <a href={href} className={wrapperClass}>
        {inner}
      </a>
    );
  }
  return (
    <button onClick={onClick} className={wrapperClass}>
      {inner}
    </button>
  );
}
